import { render, staticRenderFns } from "./Libro.vue?vue&type=template&id=b03ad980&scoped=true&"
import script from "./Libro.vue?vue&type=script&lang=js&"
export * from "./Libro.vue?vue&type=script&lang=js&"
import style0 from "./Libro.vue?vue&type=style&index=0&id=b03ad980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03ad980",
  null
  
)

export default component.exports